module.exports = __webpack_public_path__ + "img/sicomlogomin.fc1e0634.png";